import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from '../environments/environment';
import { Apps } from '../interfaces/apps.interface';

@Injectable({
  providedIn: 'root',
})
export class CurrentAppService {
  currentApp!: Apps;
  env = environment;

  constructor(@Inject(DOCUMENT) private document: Document) {
    this.getCurrentApp();
  }

  getCurrentApp() {
    const domain = this.document.location.origin;

    switch (domain) {
      case this.env.techDomain:
        this.currentApp = 'wm-tech';
        break;
      case this.env.techMmsDomain:
        this.currentApp = 'wm-tech-mms';
        break;
      case this.env.techPoolDomain:
        this.currentApp = 'wm-tech-pool';
        break;
      case this.env.adminDomain:
        this.currentApp = 'wm-admin';
        break;

      default:
        break;
    }
  }
}
